// extracted by mini-css-extract-plugin
module.exports = {"checkout-container":"CheckoutPage_checkout-container__16_C0"};